module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-10.fa87289a.JPG";